export default __webpack_public_path__ + "static/pultrudedfrp2-1e3bcd09ca9743d5e69fee30d53dd076.jpg";